jQuery(document).ready(function($){

	var validator = $('#signUpForm').validate({
		rules : {
			username: "required",
			name: "required",
			lastname: "required",
			country: "required",
			state: "required",
			city: "required",
			email: {
				required: true,
				email: true
			},
			email_confirm: {
				required: true,
				email: true
			}
		},
		messages: {
			username: "Este campo es requerido",
			name: "Este campo es requerido",
			lastname: "Este campo es requerido",
			country: "Este campo es requerido",
			state: "Este campo es requerido",
			city: "Este campo es requerido",
			email: "Este campo es requerido",
			email_confirm: "Este campo es requerido",
		},
		success:function(label){
			label.closest('div').removeClass('warning');
		},
		errorPlacement: function(error, element) {
    		error.appendTo( element.prev() );
    		element.parent('div').addClass('warning');
  		},
  		invalidHandler: function(event, validator) {
  			console.log(validator);
  			
  		},
  		onkeyup: false,
  		onfocusout: false,
  		wrapper: "small"
	});
	var validator2 = $('#contactForm').validate({
		rules : {
			nombre: "required",
			consulta: "required",
			correo: {
				required: true,
				email: true
			}
		},
		messages: {
			nombre: "Este campo es requerido",
			consulta: "Este campo es requerido",
			correo: "Este campo es requerido"
		},
		success:function(label){
			alert('a');
			label.closest('div').removeClass('warning');
		},
		/*showErrors:function(errorMap, errorList){
			console.log(errorMap);
			console.log(errorList);
			for(var i = 0; i < errorList.length; i++){
				$(errorList[i].element).closest('div').find('span').html('<small>' + errorList[i].message + '</small>');
				$(errorList[i].element).parent('div').addClass('warning');
			}
		},*/
		errorPlacement: function(error, element) {
    		error.appendTo( element.prev() );
    		element.parent('div').addClass('warning');
  		},
  		invalidHandler: function(event, validator) {
  			//console.log(validator);
  		},
  		onkeyup: false,
  		onfocusout: false,
  		wrapper: "small"
	});
	var validator3 = $('#certificateForm').validate({
		rules : {
			calle: "required",
			colonia: "required",
			cp: "required"
		},
		messages: {
			calle: "Este campo es requerido",
			colonia: "Este campo es requerido",
			cp: "Este campo es requerido"
		},
		success:function(label){
			label.closest('div').removeClass('warning');
		},
		errorPlacement: function(error, element) {
    		error.appendTo( element.prev() );
    		element.parent('div').addClass('warning');
  		},
  		invalidHandler: function(event, validator) {
  			console.log(validator);
  			
  		},
  		onkeyup: false,
  		onfocusout: false,
  		wrapper: "small"
	});
});